import MaterialTableRow from "@mui/material/TableRow";
import React, { FC } from "react";

export const TableRow: FC<any> = React.forwardRef(({ isDragging, isLoading, ...props }, ref) => (
  <MaterialTableRow {...props} ref={ref} />
));
